import { FC, useEffect, useState } from 'react';
import './dice.css';

interface Props {
    timer: number;
    value: number;
}

const F = 15;

const faces = [1, 2, 3, 4, 5, 6];

function get_random_face(exclude: number | null): number {
    const available = faces.filter((face) => face !== exclude);
    return available[Math.floor(Math.random() * available.length)];
}

function generate_sequence(scrollCount: number, result: number): number[] {
    const sequence: number[] = [];
    let lastFace: number | null = null;
    // Generate scrollCount - 1 random faces
    for (let i = 0; i < scrollCount - 1; i++) {
        const nextFace = get_random_face(lastFace);
        sequence.push(nextFace);
        lastFace = nextFace;
    }
    // If the last generated face equals result, adjust it (optional)
    if (lastFace === result && sequence.length > 0) {
        // Replacing the last face with another random face (ensuring it's not equal to its new neighbor)
        sequence[sequence.length - 1] = get_random_face(null);
    }
    // Append the desired final result
    sequence.push(result);
    return sequence;
}

export const Dice: FC<Props> = ({ value, timer }) => {
    const [sequence, set_sequence] = useState<number[]>([]);
    const [animate, set_animate] = useState(false);

    useEffect(() => {
        if (value === 0) return;
        const sequence = generate_sequence(F, value);
        set_sequence(sequence);
        set_animate(false);
        const timer = setTimeout(() => {
            set_animate(true);
        }, 50);
        return () => clearTimeout(timer);
    }, [value]);

    const get_pips = (pips: number) =>
        Array(pips)
            .fill(0)
            .map((_, index) => <span className='pip' key={index} />);

    const translate = 94 * (sequence.length - 1);

    return (
        <div className='dice'>
            <div
                className='face-list'
                style={{
                    transform: animate ? `translateY(-${translate}px)` : 'translateY(0)',
                    transition: `transform ${timer}s ease-out`,
                }}
            >
                {sequence.map((face, index) => (
                    <div key={index} className='face'>
                        {get_pips(face)}
                    </div>
                ))}
            </div>
        </div>
    );
};
